import {Button} from '@/components/common-components/v2';
import {Modal} from 'antd';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  background-color: #2D6CCA !important;
  color: #fff !important;
  min-height: 44px !important;
  min-width: 162px !important;
  border-radius: 8px !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  margin: 0 !important;
  justify-content: center;
  &:hover {
    background-color: #2D6CCA !important;
  }
`;

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    background: #fff;
    border: 1px solid #E8E8E8;
  }
  .ant-modal-close-x {
    position: absolute;
    top: -12px;
    left: 0px;
    right: -70px;
    color: white;
    svg {
      font-size: 28px;
    }
  }
  .ant-modal-body {
    padding: 18px 22px 24px;
    color: #121212;
  }

  .title {
    font-weight: 600;
    font-size: 24px;
    line-height: 28px;
  }
  .description {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    margin-top: 16px;
  }

  .checkboxWrapper {
    margin-top: 16px;
    max-height: 130px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 10px;
    // For Google Chrome
    &::-webkit-scrollbar {
      height: 6px;
      width: 6px;
    }

  &::-webkit-scrollbar-thumb {
    background: rgba(78, 81, 86, 0.3);
    border-radius: 13px;
  }

    &::-webkit-scrollbar-track {
      background: transparent;
    }
    .ant-checkbox-group {
      display: flex;
      flex-direction: column;
      gap: 3px;
      .ant-checkbox-wrapper {
        display: flex;
        gap: 4px;
        width: fit-content;
      }
    }
    .ant-checkbox-checked .ant-checkbox-inner::after {
      display: block !important;
    }
    .ant-checkbox-inner {
      border-radius: 5px !important;
    }
    .ant-checkbox:not(.ant-checkbox-disabled).ant-checkbox-checked .ant-checkbox-inner {
      background-color: #2D6CCA !important;
      border-color: #2D6CCA !important;
    }
    .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {
      border-color: #E6E6E6 !important;
    }
  }

  .button-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 36px;
    margin-top: 18px;
  }

  .cancelButton {
    outline: none;
    border: none;
    background-color: transparent;
    color: #4E5156;
    margin: 0;
    padding: 0;
    cursor: pointer;
  }
`;
